import { render, staticRenderFns } from "./DailyLiveStockTable.vue?vue&type=template&id=53f4116a&scoped=true&"
import script from "./DailyLiveStockTable.vue?vue&type=script&lang=ts&"
export * from "./DailyLiveStockTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f4116a",
  null
  
)

export default component.exports